export function formatDateTime(type, from, until = null) {
  let dateTime = type
  if (dateTime.includes('dateShort')) {
    const dateShort = new Date(from).toLocaleDateString('de-AT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    dateTime = dateTime.replace('dateShort', dateShort)
  }

  if (dateTime.includes('dateLong')) {
    const dateLong = new Date(from).toLocaleDateString('de-AT', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
    dateTime = dateTime.replace('dateLong', dateLong)
  }

  if (dateTime.includes('day')) {
    const day = new Date(from).toLocaleDateString('de-AT', {
      weekday: 'long',
    })
    dateTime = dateTime.replace('day', day)
  }

  if (dateTime.includes('timeFrom')) {
    const fromHour = new Date(from)
      .toLocaleDateString('de-AT', {
        hour: '2-digit',
        minute: '2-digit',
      })
      .slice(-5)
    dateTime = dateTime.replace('timeFrom', fromHour)
  }

  if (dateTime.includes('timeUntil')) {
    const untilHour = new Date(until)
      .toLocaleDateString('de-AT', {
        hour: '2-digit',
        minute: '2-digit',
      })
      .slice(-5)
    dateTime = dateTime.replace('timeUntil', untilHour)
  }

  return dateTime
}

export function formatDuration(minutes) {
  if (minutes % 60) {
    if (Math.floor(minutes / 60)) {
      return `${Math.floor(minutes / 60)} h ${minutes % 60} min`
    } else {
      return `${minutes % 60} min`
    }
  } else {
    return `${minutes / 60} h`
  }
}

export function getDuration(from, until) {
  const fromDate = new Date(from)
  const untilDate = new Date(until)
  const minutes = (untilDate - fromDate) / 1000 / 60

  return formatDuration(minutes)
}

export function getLastSunday(initialDate) {
  const date = initialDate ? new Date(initialDate) : new Date()
  date.setDate(date.getDate() - date.getDay())
  return convertDateFormat(date)
}

export function getNextSunday(initialDate) {
  const date = initialDate ? new Date(initialDate) : new Date()
  date.setDate(date.getDate() - date.getDay() + 7)
  return convertDateFormat(date)
}

export function getPreviousDate(initialDate, number) {
  const date = new Date(initialDate)
  date.setDate(date.getDate() - number)
  return convertDateFormat(date)
}

export function getNextDate(initialDate, number) {
  const date = new Date(initialDate)
  date.setDate(date.getDate() + number)
  return convertDateFormat(date)
}

export function getNextDayOfWeek(initialDate, dayOfWeek) {
  const date = new Date(initialDate)
  date.setDate(date.getDate() + ((7 + dayOfWeek - date.getDay()) % 7))
  // dayOfWeek is 0 Sunday - 6 Saturday
  return convertDateFormat(date)
}

export function getMonth(date) {
  return new Date(date).toLocaleDateString('de-AT', {
    month: 'long',
  })
}

export function getFirstDateOfMonth(date) {
  const firstDateOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
  return convertDateFormat(firstDateOfMonth)
}

export function getLastDateOfMonth(date) {
  const lastDateOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  return convertDateFormat(lastDateOfMonth)
}

export function convertYYYYMMDDMinutesToDate(date, minutes) {
  const [YYYY, MM, DD] = date.split('-')
  const hh = Math.floor(minutes / 60).toLocaleString('de-AT', { minimumIntegerDigits: 2 })
  const mm = (minutes - +hh * 60).toLocaleString('de-AT', { minimumIntegerDigits: 2 })

  return new Date(YYYY, +MM - 1, DD, hh, mm)
}

export function convertDateFormat(date) {
  const yyyy = date.getFullYear()
  const mm = (date.getMonth() + 1).toLocaleString('de-AT', { minimumIntegerDigits: 2 })
  const dd = date.getDate().toLocaleString('de-AT', { minimumIntegerDigits: 2 })
  return `${yyyy}-${mm}-${dd}`
}

export function minutesToHHMM(minutes) {
  const hh = Math.floor(minutes / 60).toLocaleString('de-AT', { minimumIntegerDigits: 2 })
  const mm = (minutes - +hh * 60).toLocaleString('de-AT', { minimumIntegerDigits: 2 })
  return `${hh}:${mm}`
}

export function getTimeToday() {
  const date = new Date()

  return date.getHours() * 60 + date.getMinutes()
}

export function getDateYearsAgoToday(numOfYears) {
  // eg numOfYears = 3 is 3 years ago from today
  const date = new Date()
  date.setFullYear(date.getFullYear() - numOfYears)
  return date
}

export function removeDuplicates(array) {
  return array.reduce(function (previousValue, currentValue) {
    if (previousValue.indexOf(currentValue) === -1) {
      previousValue.push(currentValue)
    }
    return previousValue
  }, [])
}

export function clusterTimeslots(timeslots) {
  let clusteredTimeslots = []

  for (let i = 0; i < timeslots.length; i++) {
    const previous = Math.floor(timeslots[i - 1]?.von / 60)
    const current = Math.floor(timeslots[i]?.von / 60)
    const nextNextNext = Math.floor(timeslots[i + 3]?.von / 60)
    // cluster if there are more than 3 timeslots of that hour

    if (current !== previous) {
      if (current !== nextNextNext) {
        clusteredTimeslots.push(timeslots[i])
      } else {
        clusteredTimeslots.push([timeslots[i]])
      }
    } else {
      if (Array.isArray(clusteredTimeslots[clusteredTimeslots.length - 1])) {
        clusteredTimeslots[clusteredTimeslots.length - 1].push(timeslots[i])
      } else {
        clusteredTimeslots.push(timeslots[i])
      }
    }
  }

  return clusteredTimeslots
}

export function convertToSlug(bezeichnung) {
  return bezeichnung
    .toLocaleLowerCase()
    .trim()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/\W/g, '-')
    .replace(/-+/g, '-')
}

export function convertFromSlug(slug) {
  // does not match above function exactly
  const bezeichnung = slug
    .replace(/ae/g, 'ä')
    .replace(/oe/g, 'ö')
    .replace(/ue/g, 'ü')
    .replace(/ss/g, 'ß')
    .replace(/-/g, ' ')

  return slug[0].toUpperCase() + bezeichnung.slice(1)
}
